import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'EmbeddedImage' })(
  ({ breakpoints, spacing, brandColors }) => ({
    grid: {
      justifyContent: 'center',
    },
    image: {
      width: '100%',
      maxWidth: '100%',
      borderRadius: spacing(-1),
    },
    mobileImage: {
      [breakpoints.up('md')]: {
        display: 'none',
      },
    },
    hiddenOnMobile: {
      display: 'none',
      [breakpoints.up('md')]: {
        display: 'initial',
      },
    },
    caption: {
      whiteSpace: 'pre-wrap',
      color: brandColors.tintsNeutral20,
      marginTop: spacing(1),
    },
  })
);

export default useStyles;
